import { Typography } from './theme.types';

const BODY_LINE_HEIGHT = '1.5';
const TITLE_LINE_HEIGHT = '1.3';
const HEADING_LINE_HEIGHT = '1.3';

export const typography: Typography = {
  body1: {
    mobile: {
      fontSize: '1rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '1rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
  },
  body2: {
    mobile: {
      fontSize: '0.875rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '0.875rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
  },
  body3: {
    mobile: {
      fontSize: '0.75rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '0.75rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
  },
  body4: {
    mobile: {
      fontSize: '0.625rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '0.625rem',
      lineHeight: BODY_LINE_HEIGHT,
    },
  },
  title1: {
    mobile: {
      fontSize: '1.625rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '2rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
  },
  title2: {
    mobile: {
      fontSize: '1.375rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '1.625rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
  },
  title3: {
    mobile: {
      fontSize: '1.25rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '1.375rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
  },
  title4: {
    mobile: {
      fontSize: '1.125rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '1.25rem',
      lineHeight: TITLE_LINE_HEIGHT,
    },
  },
  heading1: {
    mobile: {
      fontSize: '2.5rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '3.25rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
  },
  heading2: {
    mobile: {
      fontSize: '2.25rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '2.875rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
  },
  heading3: {
    mobile: {
      fontSize: '2rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '2.5rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
  },
  heading4: {
    mobile: {
      fontSize: '1.75rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
    desktop: {
      fontSize: '2.25rem',
      lineHeight: HEADING_LINE_HEIGHT,
    },
  },
};
